<kc-dialog>
  <ng-template #contentTemplate>
    <div class="settings-content" [formGroup]="settingsForm">
      <div class="form-field">
        <div class="slippage-row">
          <kc-number-input
            [infoLabel]="{ label: 'Slippage tolerance (%)' }"
            [enforceEthersFormat]="false"
            placeholder="0.5"
            formControlName="maxSlippage"
          />
          <div
            class="slippage-options flex gap-8"
            role="group"
            aria-label="Select slippage tolerance"
          >
            @for (option of slippageOptions; track option.value) {
              <kc-button
                [text]="option.label"
                [variant]="'tag-secondary'"
                [isSelected]="selectedSlippage() === option.value"
                (buttonClick)="onSlippageClick($any(option.value))"
              />
            }
          </div>
        </div>
        <kc-form-error-message
          [control]="settingsForm.get('maxSlippage')"
          fieldName="Slippage"
          validPatternExample="0.5"
          [customErrorMessages]="{
            min: 'Slippage must be at least 0.01%',
            max: 'Slippage cannot exceed 50%',
          }"
        />
      </div>

      <div class="form-field">
        <kc-number-input
          [infoLabel]="{ label: 'Transaction deadline (minutes)' }"
          [enforceEthersFormat]="false"
          placeholder="20"
          formControlName="swapDeadline"
        />
        <kc-form-error-message
          [control]="settingsForm.get('swapDeadline')"
          fieldName="Deadline"
          [customErrorMessages]="{
            min: 'Deadline must be at least 1 minute',
            max: 'Deadline cannot exceed 4320 minutes (3 days)',
          }"
        />
      </div>

      <kc-button
        text="Save"
        variant="primary"
        [isFullWidth]="true"
        [isDisabled]="settingsForm.invalid"
        (buttonClick)="onSave()"
      />
    </div>
  </ng-template>
</kc-dialog>
